module.exports = __webpack_public_path__ + "media/app/images/success_payment@2x-f388be8474ef4367f5296faeb381c720.png";